import React from "react";
import ReviewsTable from "../Other/ReviewsTable";

const WebsiteReviews = () => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Website reviews</h2>
        <p className="app-muted text-sm">
          Scan through customer feedback gathered from the site.
        </p>
      </div>
      <div className="app-surface overflow-hidden rounded-xl border">
        <div className="overflow-x-auto">
          <ReviewsTable />
        </div>
      </div>
    </div>
  );
};

export default WebsiteReviews;
